import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth, UserRole } from '../contexts/AuthContext';
interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles?: UserRole[];
  requirePermission?: string;
}
export function ProtectedRoute({
  children,
  allowedRoles,
  requirePermission
}: ProtectedRouteProps) {
  const {
    isAuthenticated,
    user,
    hasRole,
    hasPermission
  } = useAuth();
  if (!isAuthenticated) {
    return <Navigate to="/login" replace data-id="element-312" />;
  }
  if (allowedRoles && !hasRole(allowedRoles)) {
    // Redirect ke dashboard yang sesuai dengan role user
    switch (user?.role) {
      case 'super_admin':
        return <Navigate to="/admin/dashboard" replace data-id="element-313" />;
      case 'ketua_chapter':
      case 'ketua_student_chapter':
        return <Navigate to="/chapter/dashboard" replace data-id="element-314" />;
      case 'komite_pusat':
        return <Navigate to="/committee/dashboard" replace data-id="element-315" />;
      case 'koordinator_acara':
        return <Navigate to="/events/manage" replace data-id="element-316" />;
      case 'bendahara':
        return <Navigate to="/finance/dashboard" replace data-id="element-317" />;
      case 'anggota_individu':
      case 'anggota_organisasi':
      case 'anggota_badan_usaha':
      case 'mitra_asosiasi':
      default:
        return <Navigate to="/dashboard" replace data-id="element-318" />;
    }
  }
  if (requirePermission && !hasPermission(requirePermission)) {
    return <Navigate to="/unauthorized" replace data-id="element-319" />;
  }
  return <>{children}</>;
}